﻿/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.3.0.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://beercollective-dev.azurewebsites.net";
    }

    postPostcode(files: FileParameter[] | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Uploadpostcodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPostcode(_response);
        });
    }

    protected processPostPostcode(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    post(files: FileParameter[] | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class ProductsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://beercollective-dev.azurewebsites.net";
    }

    updateProduct(product: Product): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/site/Products/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProduct(_response);
        });
    }

    protected processUpdateProduct(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    jsonzIndex(categories: string[] | null | undefined, subcategories: string[] | null | undefined, offset: number | undefined, count: number | undefined, searchterm: string | null | undefined, all: boolean | undefined): Promise<Product[]> {
        let url_ = this.baseUrl + "/api/site/Products/jsonproducts?";
        if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "categories=" + encodeURIComponent("" + item) + "&"; });
        if (subcategories !== undefined)
            subcategories && subcategories.forEach(item => { url_ += "subcategories=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&"; 
        if (searchterm !== undefined)
            url_ += "searchterm=" + encodeURIComponent("" + searchterm) + "&"; 
        if (all === null)
            throw new Error("The parameter 'all' cannot be null.");
        else if (all !== undefined)
            url_ += "all=" + encodeURIComponent("" + all) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJsonzIndex(_response);
        });
    }

    protected processJsonzIndex(response: Response): Promise<Product[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Product[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product[]>(<any>null);
    }
}

export class AuthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://beercollective-dev.azurewebsites.net";
    }

    authenticate(loginViewModel: LoginViewModel): Promise<AuthViewModel> {
        let url_ = this.baseUrl + "/api/Auth/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginViewModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: Response): Promise<AuthViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthViewModel>(<any>null);
    }

    createUser(model: SignUpModelForJolse): Promise<AuthViewModel> {
        let url_ = this.baseUrl + "/api/Auth/createuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<AuthViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthViewModel>(<any>null);
    }

    confirmEmail(userId: string | null, code: string | null): Promise<AuthViewModel> {
        let url_ = this.baseUrl + "/api/Auth/confirmemail/{userId}/{code}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmEmail(_response);
        });
    }

    protected processConfirmEmail(response: Response): Promise<AuthViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthViewModel>(<any>null);
    }

    changePassword(cpvm: ChangePasswordViewModel): Promise<AuthViewModel> {
        let url_ = this.baseUrl + "/api/Auth/changepassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cpvm);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<AuthViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthViewModel>(<any>null);
    }

    forgotPassword(model: ForgotPasswordViewModel): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Auth/forgotpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    resetPassword(model: ResetPasswordForJolse): Promise<AuthViewModel> {
        let url_ = this.baseUrl + "/api/Auth/resetpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<AuthViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthViewModel>(<any>null);
    }
}

export class CartClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://beercollective-dev.azurewebsites.net";
    }

    addCart(cart: Cart): Promise<string> {
        let url_ = this.baseUrl + "/api/Cart/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cart);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddCart(_response);
        });
    }

    protected processAddCart(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    updateCartItem(item: CartItemDTO): Promise<CartItem> {
        let url_ = this.baseUrl + "/api/Cart/cartitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCartItem(_response);
        });
    }

    protected processUpdateCartItem(response: Response): Promise<CartItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CartItem>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CartItem>(<any>null);
    }

    addItemToCart(item: CartItemDTO): Promise<CartItem> {
        let url_ = this.baseUrl + "/api/Cart/cartitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddItemToCart(_response);
        });
    }

    protected processAddItemToCart(response: Response): Promise<CartItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CartItem>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CartItem>(<any>null);
    }

    deleteCartItem(item: CartItemDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Cart/removecartitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCartItem(_response);
        });
    }

    protected processDeleteCartItem(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    convertCartToSale(cartDTO: ConvertCartDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/Cart/convertcart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cartDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConvertCartToSale(_response);
        });
    }

    protected processConvertCartToSale(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    convertCartToSubscription(cartDTO: ConvertCartDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/Cart/convertcartosub";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cartDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConvertCartToSubscription(_response);
        });
    }

    protected processConvertCartToSubscription(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    getCartItems(): Promise<CartForJolse> {
        let url_ = this.baseUrl + "/api/Cart/cartitems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCartItems(_response);
        });
    }

    protected processGetCartItems(response: Response): Promise<CartForJolse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CartForJolse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CartForJolse>(<any>null);
    }

    calculateCost(pickup: boolean | undefined, username: string | null | undefined): Promise<Cart> {
        let url_ = this.baseUrl + "/api/Cart?";
        if (pickup === null)
            throw new Error("The parameter 'pickup' cannot be null.");
        else if (pickup !== undefined)
            url_ += "pickup=" + encodeURIComponent("" + pickup) + "&"; 
        if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalculateCost(_response);
        });
    }

    protected processCalculateCost(response: Response): Promise<Cart> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Cart>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Cart>(<any>null);
    }
}

export class ClubPackClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://beercollective-dev.azurewebsites.net";
    }

    getClubPacks(business: string | null, customerId: string | null | undefined): Promise<ClubPack[]> {
        let url_ = this.baseUrl + "/api/ClubPack/packs/{business}?";
        if (business === undefined || business === null)
            throw new Error("The parameter 'business' must be defined.");
        url_ = url_.replace("{business}", encodeURIComponent("" + business)); 
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClubPacks(_response);
        });
    }

    protected processGetClubPacks(response: Response): Promise<ClubPack[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ClubPack[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubPack[]>(<any>null);
    }

    getProductBoxes(business: string | null): Promise<ProductBox[]> {
        let url_ = this.baseUrl + "/api/ClubPack/productboxes/{business}";
        if (business === undefined || business === null)
            throw new Error("The parameter 'business' must be defined.");
        url_ = url_.replace("{business}", encodeURIComponent("" + business)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductBoxes(_response);
        });
    }

    protected processGetProductBoxes(response: Response): Promise<ProductBox[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductBox[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductBox[]>(<any>null);
    }

    getBox(id: string): Promise<ClubPackBox> {
        let url_ = this.baseUrl + "/api/ClubPack/box/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBox(_response);
        });
    }

    protected processGetBox(response: Response): Promise<ClubPackBox> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ClubPackBox>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubPackBox>(<any>null);
    }

    getPack(id: string, includeBoxes: boolean | undefined): Promise<ClubPack> {
        let url_ = this.baseUrl + "/api/ClubPack/pack/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (includeBoxes === null)
            throw new Error("The parameter 'includeBoxes' cannot be null.");
        else if (includeBoxes !== undefined)
            url_ += "includeBoxes=" + encodeURIComponent("" + includeBoxes) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPack(_response);
        });
    }

    protected processGetPack(response: Response): Promise<ClubPack> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ClubPack>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubPack>(<any>null);
    }

    getImage(id: string, fullSize: boolean | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ClubPack/image/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (fullSize === null)
            throw new Error("The parameter 'fullSize' cannot be null.");
        else if (fullSize !== undefined)
            url_ += "fullSize=" + encodeURIComponent("" + fullSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImage(_response);
        });
    }

    protected processGetImage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    signUp(cpsu: ClubPackSignupViewModel): Promise<Customer> {
        let url_ = this.baseUrl + "/api/ClubPack/signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cpsu);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignUp(_response);
        });
    }

    protected processSignUp(response: Response): Promise<Customer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Customer>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer>(<any>null);
    }

    getCustomer(id: string): Promise<Customer> {
        let url_ = this.baseUrl + "/api/ClubPack/customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomer(_response);
        });
    }

    protected processGetCustomer(response: Response): Promise<Customer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Customer>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer>(<any>null);
    }

    updateCustomer(customer: Customer): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ClubPack/customer/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customer);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomer(_response);
        });
    }

    protected processUpdateCustomer(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    processRefferals(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ClubPack/processrefferals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessRefferals(_response);
        });
    }

    protected processProcessRefferals(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    processClubPacks(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ClubPack/processclubpacks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessClubPacks(_response);
        });
    }

    protected processProcessClubPacks(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    addBoxToOrder(rbvm: RewardBoxViewModel): Promise<Session> {
        let url_ = this.baseUrl + "/api/ClubPack/addboxtoorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rbvm);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBoxToOrder(_response);
        });
    }

    protected processAddBoxToOrder(response: Response): Promise<Session> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Session>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Session>(<any>null);
    }

    addSubscriptionToOrder(ssvm: SubscriptionSignupViewModel): Promise<Session> {
        let url_ = this.baseUrl + "/api/ClubPack/addSubscriptionToOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ssvm);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddSubscriptionToOrder(_response);
        });
    }

    protected processAddSubscriptionToOrder(response: Response): Promise<Session> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Session>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Session>(<any>null);
    }
}

export class ConfigClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://beercollective-dev.azurewebsites.net";
    }

    getConfig(business: string | null): Promise<ExternalAppConfig> {
        let url_ = this.baseUrl + "/api/Config/config/{business}";
        if (business === undefined || business === null)
            throw new Error("The parameter 'business' must be defined.");
        url_ = url_.replace("{business}", encodeURIComponent("" + business)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConfig(_response);
        });
    }

    protected processGetConfig(response: Response): Promise<ExternalAppConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ExternalAppConfig>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalAppConfig>(<any>null);
    }

    getMethods(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Config/cartmethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMethods(_response);
        });
    }

    protected processGetMethods(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class OrdersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://beercollective-dev.azurewebsites.net";
    }

    orderHistory(): Promise<OrderHistoryDTO[]> {
        let url_ = this.baseUrl + "/api/Orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrderHistory(_response);
        });
    }

    protected processOrderHistory(response: Response): Promise<OrderHistoryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrderHistoryDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderHistoryDTO[]>(<any>null);
    }
}

export class ProductClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://beercollective-dev.azurewebsites.net";
    }

    listProducts(categories: string[] | null | undefined, subcategories: string[] | null | undefined, offset: number | undefined, count: number | undefined, searchterm: string | null | undefined, all: boolean | undefined): Promise<ProductDTO[]> {
        let url_ = this.baseUrl + "/api/Product?";
        if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "categories=" + encodeURIComponent("" + item) + "&"; });
        if (subcategories !== undefined)
            subcategories && subcategories.forEach(item => { url_ += "subcategories=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&"; 
        if (searchterm !== undefined)
            url_ += "searchterm=" + encodeURIComponent("" + searchterm) + "&"; 
        if (all === null)
            throw new Error("The parameter 'all' cannot be null.");
        else if (all !== undefined)
            url_ += "all=" + encodeURIComponent("" + all) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListProducts(_response);
        });
    }

    protected processListProducts(response: Response): Promise<ProductDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductDTO[]>(<any>null);
    }

    categories(category: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Product/categories?";
        if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategories(_response);
        });
    }

    protected processCategories(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    autoCompleteCategories(searchTerm: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Product/autocompletecategories?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutoCompleteCategories(_response);
        });
    }

    protected processAutoCompleteCategories(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    autoCompleteSubCategories(searchTerm: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Product/autocompletesubcategories?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutoCompleteSubCategories(_response);
        });
    }

    protected processAutoCompleteSubCategories(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class StripeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://beercollective-dev.azurewebsites.net";
    }

    doDesionStuff(customerId: string): Promise<Session> {
        let url_ = this.baseUrl + "/api/Stripe/session/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDoDesionStuff(_response);
        });
    }

    protected processDoDesionStuff(response: Response): Promise<Session> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Session>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Session>(<any>null);
    }
}

export class StripeWebHooksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://beercollective-dev.azurewebsites.net";
    }

    index(stripeBusinessName: string | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/{stripeBusinessName}/StripeWebHooks";
        if (stripeBusinessName === undefined || stripeBusinessName === null)
            throw new Error("The parameter 'stripeBusinessName' must be defined.");
        url_ = url_.replace("{stripeBusinessName}", encodeURIComponent("" + stripeBusinessName)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export interface Product {
    productID: string;
    name: string;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    tax: number;
    imageId?: string | undefined;
    variants?: ProductVariant[] | undefined;
    active: boolean;
    showRemainingUnitsOnShop: boolean;
    applyMaximumPurchaseNumber: boolean;
    maxPurchaseUnits: number;
}

export interface ProductVariant {
    id: string;
    name?: string | undefined;
    shortDescription?: string | undefined;
    amount: number;
    active: boolean;
}

export interface AuthViewModel {
    token?: string | undefined;
    customerId?: string | undefined;
}

export interface LoginViewModel {
    email: string;
    password: string;
    rememberMe: boolean;
}

export interface SignUpModelForJolse {
    email: string;
    password: string;
    confirmPassword?: string | undefined;
    referrer?: string | undefined;
    confirmAccountUrl: string;
    firstName: string;
    lastName: string;
    mobileNumber?: string | undefined;
    dateOfBirth: string;
}

export interface ChangePasswordViewModel {
    oldPassword: string;
    newPassword: string;
    confirmPassword?: string | undefined;
}

export interface ForgotPasswordViewModel {
    email: string;
    restPasswordUrl?: string | undefined;
}

export interface ResetPasswordForJolse {
    userId?: string | undefined;
    password: string;
    confirmPassword?: string | undefined;
    code?: string | undefined;
}

export interface Cart {
    id: string;
    cartItems?: CartItem[] | undefined;
    customerId?: string | undefined;
    username?: string | undefined;
    guest: boolean;
    shippingAddress?: Address | undefined;
    billingAddress?: Address | undefined;
}

export interface CartItem {
    id: string;
    product?: Product | undefined;
    quantity: number;
    cartTotal: number;
}

export interface Address {
    addressId: string;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postcode: number;
}

export interface CartItemDTO {
    productId: string;
    quantity: number;
}

export interface ConvertCartDTO {
    username?: string | undefined;
    successUrl?: string | undefined;
    cancelUrl?: string | undefined;
    pickup: boolean;
}

export interface CartForJolse {
    cartItems?: CartItem[] | undefined;
    customerId?: string | undefined;
    postage?: PostageForJolse | undefined;
}

export interface PostageForJolse {
    description?: string | undefined;
    amount: number;
}

export interface ClubPack {
    id: string;
    name?: string | undefined;
    price: number;
    description?: string | undefined;
    boxes?: ClubPackBox[] | undefined;
    active: boolean;
    customerIsSubscribed: boolean;
    customCustomerSubscription: boolean;
    stripePlanId?: string | undefined;
}

export interface ClubPackBox {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    active: boolean;
    future: boolean;
    imageId?: string | undefined;
    items?: ClubPackLine[] | undefined;
    boxMonth?: string | undefined;
    referrerBox: boolean;
    referrerCreditRequired: number;
}

export interface ClubPackLine {
    id: string;
    quantity: number;
    product?: Product | undefined;
    amount: number;
}

export interface ProductBox {
    id: string;
    customer?: Customer | undefined;
    price: number;
    name?: string | undefined;
    description?: string | undefined;
    active: boolean;
    imageId?: string | undefined;
    items?: ClubPackLine[] | undefined;
}

export interface Customer {
    customerID: string;
    firstName?: string | undefined;
    lastName: string;
    emailAddress?: string | undefined;
    homePhone?: string | undefined;
    mobilePhone?: string | undefined;
    postalAddress?: Address | undefined;
    billingAddress?: Address | undefined;
    fullName?: string | undefined;
    applyWet: boolean;
    customPriceLevel: boolean;
    productPriceLevel?: ProductPriceLevel | undefined;
    billingSameAsPostal: boolean;
    totalReferralCount: number;
    currentReferralCreditCount: number;
    referrals?: CustomerReferral[] | undefined;
    stripeCustomerId?: string | undefined;
    signUpDate: string;
    notes?: string | undefined;
    dateOfBirth?: string | undefined;
}

export interface ProductPriceLevel {
    productPriceLevelID: string;
    name?: string | undefined;
    description?: string | undefined;
    business?: Business | undefined;
}

export interface Business {
    businessID: string;
    name: string;
    registeredAddress?: Address | undefined;
    streetSameAsRegistered: boolean;
    streetAddress?: Address | undefined;
    emailAddress: string;
    homePhone?: string | undefined;
    mobilePhone?: string | undefined;
    abn: string;
    applyGST: boolean;
    taxAmount: number;
    applyWET: boolean;
    wetAmount: number;
    defaultPaymentTerms: number;
    invoiceLayoutDetails?: InvoiceLayoutDetails | undefined;
    percentDiscount: number;
    numOfItems: number;
    stripeId?: string | undefined;
    shortName?: string | undefined;
    stripeAPIKey?: string | undefined;
    stripeWebHookKey?: string | undefined;
    sendGridAPIKey?: string | undefined;
    sendgridInvoiceTemplateId?: string | undefined;
    sendgridOrderReadyTemplateId?: string | undefined;
    sendgridOrderReceivedTemplateId?: string | undefined;
    sendOrderReadyEmail: boolean;
    sendOrderReceivedEmail: boolean;
    showOutstandingOrdersOnDashBoard: boolean;
    showOutstandingInvoicesOnDashBoard: boolean;
}

export interface InvoiceLayoutDetails {
    invoiceLayDetailsID: string;
    paymentTermsText?: string | undefined;
    termsAndConditions?: string | undefined;
    logo?: string | undefined;
    bankDetails?: BankDetails | undefined;
}

export interface BankDetails {
    bankDetailsId: string;
    business?: Business | undefined;
    accountName?: string | undefined;
    bsb?: string | undefined;
    accountNumber?: string | undefined;
}

export interface CustomerReferral {
    id: string;
    customerId: string;
    customer?: Customer | undefined;
    verificationCode?: string | undefined;
    active: boolean;
    utilised: boolean;
    usernameReferred?: string | undefined;
}

export interface ClubPackSignupViewModel {
    customer?: Customer | undefined;
    clubPackId?: string | undefined;
    username?: string | undefined;
}

export interface StripeEntity {
}

export interface Session extends StripeEntity {
    id?: string | undefined;
    object?: string | undefined;
    billing_address_collection?: string | undefined;
    cancel_url?: string | undefined;
    client_reference_id?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    customer_email?: string | undefined;
    display_items?: SessionDisplayItem[] | undefined;
    livemode: boolean;
    locale?: string | undefined;
    mode?: string | undefined;
    payment_intent?: ExpandableFieldOfPaymentIntent | undefined;
    payment_method_types?: string[] | undefined;
    setup_intent?: ExpandableFieldOfSetupIntent | undefined;
    subscription?: ExpandableFieldOfSubscription | undefined;
    submit_type?: string | undefined;
    success_url?: string | undefined;
}

export interface ExpandableFieldOfCustomer {
    id?: string | undefined;
    expandedObject?: Customer2 | undefined;
}

export interface StripeEntityOfCustomer extends StripeEntity {
}

export interface Customer2 extends StripeEntityOfCustomer {
    id?: string | undefined;
    object?: string | undefined;
    account_balance: number;
    address?: Address2 | undefined;
    balance: number;
    created: string;
    currency?: string | undefined;
    default_source?: ExpandableFieldOfIPaymentSource | undefined;
    default_source_type?: string | undefined;
    deleted?: boolean | undefined;
    delinquent: boolean;
    description?: string | undefined;
    discount?: Discount | undefined;
    email?: string | undefined;
    invoice_prefix?: string | undefined;
    invoice_settings?: CustomerInvoiceSettings | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    preferred_locales?: string[] | undefined;
    shipping?: Shipping | undefined;
    sources?: StripeListOfIPaymentSource | undefined;
    subscriptions?: StripeListOfSubscription | undefined;
    tax_exempt?: string | undefined;
    tax_ids?: StripeListOfTaxId | undefined;
    tax_info?: CustomerTaxInfo | undefined;
    tax_info_verification?: CustomerTaxInfoVerification | undefined;
}

export interface StripeEntityOfAddress extends StripeEntity {
}

export interface Address2 extends StripeEntityOfAddress {
    city?: string | undefined;
    country?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    postal_code?: string | undefined;
    state?: string | undefined;
}

export interface ExpandableFieldOfIPaymentSource {
    id?: string | undefined;
    expandedObject?: IPaymentSource | undefined;
}

export interface IPaymentSource {
}

export interface StripeEntityOfDiscount extends StripeEntity {
}

export interface Discount extends StripeEntityOfDiscount {
    object?: string | undefined;
    coupon?: Coupon | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    deleted?: boolean | undefined;
    end?: string | undefined;
    start?: string | undefined;
    subscription?: ExpandableFieldOfSubscription | undefined;
}

export interface StripeEntityOfCoupon extends StripeEntity {
}

export interface Coupon extends StripeEntityOfCoupon {
    id?: string | undefined;
    object?: string | undefined;
    amount_off?: number | undefined;
    created: string;
    currency?: string | undefined;
    deleted?: boolean | undefined;
    duration?: string | undefined;
    duration_in_months?: number | undefined;
    livemode: boolean;
    max_redemptions?: number | undefined;
    metadata?: { [key: string]: string; } | undefined;
    name?: string | undefined;
    percent_off?: number | undefined;
    redeem_by?: string | undefined;
    times_redeemed: number;
    valid: boolean;
}

export interface ExpandableFieldOfSubscription {
    id?: string | undefined;
    expandedObject?: Subscription | undefined;
}

export interface StripeEntityOfSubscription extends StripeEntity {
}

export interface Subscription extends StripeEntityOfSubscription {
    id?: string | undefined;
    object?: string | undefined;
    application_fee_percent?: number | undefined;
    billing?: Billing | undefined;
    billing_cycle_anchor?: string | undefined;
    billing_thresholds?: SubscriptionBillingThresholds | undefined;
    cancel_at?: string | undefined;
    cancel_at_period_end: boolean;
    canceled_at?: string | undefined;
    collection_method?: string | undefined;
    created?: string | undefined;
    current_period_end?: string | undefined;
    current_period_start?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    days_until_due?: number | undefined;
    default_payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    default_source?: ExpandableFieldOfIPaymentSource | undefined;
    default_tax_rates?: TaxRate[] | undefined;
    discount?: Discount | undefined;
    ended_at?: string | undefined;
    items?: StripeListOfSubscriptionItem | undefined;
    latest_invoice?: ExpandableFieldOfInvoice | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    pending_setup_intent?: ExpandableFieldOfSetupIntent | undefined;
    plan?: Plan | undefined;
    quantity?: number | undefined;
    schedule?: ExpandableFieldOfSubscriptionSchedule | undefined;
    start?: string | undefined;
    start_date?: string | undefined;
    status?: string | undefined;
    tax_percent?: number | undefined;
    transfer_data?: SubscriptionTransferData | undefined;
    trial_end?: string | undefined;
    trial_start?: string | undefined;
}

export enum Billing {
    ChargeAutomatically = "charge_automatically",
    SendInvoice = "send_invoice",
}

export interface StripeEntityOfSubscriptionBillingThresholds extends StripeEntity {
}

export interface SubscriptionBillingThresholds extends StripeEntityOfSubscriptionBillingThresholds {
    amount_gte?: number | undefined;
    reset_billing_cycle_anchor?: boolean | undefined;
}

export interface ExpandableFieldOfPaymentMethod {
    id?: string | undefined;
    expandedObject?: PaymentMethod | undefined;
}

export interface PaymentMethod extends StripeEntity {
    id?: string | undefined;
    object?: string | undefined;
    billing_details?: BillingDetails | undefined;
    card?: PaymentMethodCard | undefined;
    card_present?: PaymentMethodCardPresent | undefined;
    created?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    type?: string | undefined;
}

export interface BillingDetails extends StripeEntity {
    address?: Address2 | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
}

export interface PaymentMethodCard extends StripeEntity {
    brand?: string | undefined;
    checks?: PaymentMethodCardChecks | undefined;
    country?: string | undefined;
    exp_month: number;
    exp_year: number;
    fingerprint?: string | undefined;
    funding?: string | undefined;
    last4?: string | undefined;
    three_d_secure_usage?: PaymentMethodCardThreeDSecureUsage | undefined;
    wallet?: PaymentMethodCardWallet | undefined;
}

export interface PaymentMethodCardChecks extends StripeEntity {
    address_line1_check?: string | undefined;
    address_postal_code_check?: string | undefined;
    cvc_check?: string | undefined;
}

export interface PaymentMethodCardThreeDSecureUsage extends StripeEntity {
    supported?: boolean | undefined;
}

export interface PaymentMethodCardWallet extends StripeEntity {
    amex_express_checkout?: PaymentMethodCardWalletAmexExpressCheckout | undefined;
    apple_pay?: PaymentMethodCardWalletApplePay | undefined;
    dynamic_last4?: string | undefined;
    google_pay?: PaymentMethodCardWalletGooglePay | undefined;
    masterpass?: PaymentMethodCardWalletMasterpass | undefined;
    samsung_pay?: PaymentMethodCardWalletSamsungPay | undefined;
    type?: string | undefined;
    visa_checkout?: PaymentMethodCardWalletVisaCheckout | undefined;
}

export interface PaymentMethodCardWalletAmexExpressCheckout extends StripeEntity {
}

export interface PaymentMethodCardWalletApplePay extends StripeEntity {
}

export interface PaymentMethodCardWalletGooglePay extends StripeEntity {
}

export interface PaymentMethodCardWalletMasterpass extends StripeEntity {
    billing_address?: Address2 | undefined;
    email?: string | undefined;
    name?: string | undefined;
    shipping_address?: Address2 | undefined;
}

export interface PaymentMethodCardWalletSamsungPay extends StripeEntity {
}

export interface PaymentMethodCardWalletVisaCheckout extends StripeEntity {
    billing_address?: Address2 | undefined;
    email?: string | undefined;
    name?: string | undefined;
    shipping_address?: Address2 | undefined;
}

export interface PaymentMethodCardPresent extends StripeEntity {
}

export interface TaxRate extends StripeEntity {
    id?: string | undefined;
    object?: string | undefined;
    active: boolean;
    created?: string | undefined;
    description?: string | undefined;
    display_name?: string | undefined;
    inclusive: boolean;
    jurisdiction?: string | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    percentage: number;
}

export interface StripeEntityOfStripeListOfSubscriptionItem extends StripeEntity {
}

export interface StripeListOfSubscriptionItem extends StripeEntityOfStripeListOfSubscriptionItem {
    object?: string | undefined;
    data?: SubscriptionItem[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface StripeEntityOfSubscriptionItem extends StripeEntity {
}

export interface SubscriptionItem extends StripeEntityOfSubscriptionItem {
    id?: string | undefined;
    object?: string | undefined;
    created: string;
    deleted?: boolean | undefined;
    metadata?: { [key: string]: string; } | undefined;
    plan?: Plan | undefined;
    quantity: number;
    subscription?: string | undefined;
    tax_rates?: TaxRate[] | undefined;
}

export interface StripeEntityOfPlan extends StripeEntity {
}

export interface Plan extends StripeEntityOfPlan {
    id?: string | undefined;
    object?: string | undefined;
    active: boolean;
    aggregate_usage?: string | undefined;
    amount?: number | undefined;
    amount_decimal?: number | undefined;
    billing_scheme?: string | undefined;
    created: string;
    currency?: string | undefined;
    deleted?: boolean | undefined;
    interval?: string | undefined;
    interval_count: number;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    nickname?: string | undefined;
    product?: ExpandableFieldOfProduct | undefined;
    tiers?: PlanTier[] | undefined;
    tiers_mode?: string | undefined;
    transform_usage?: PlanTransformUsage | undefined;
    trial_period_days?: number | undefined;
    usage_type?: string | undefined;
}

export interface ExpandableFieldOfProduct {
    id?: string | undefined;
    expandedObject?: Product2 | undefined;
}

export interface StripeEntityOfProduct extends StripeEntity {
}

export interface Product2 extends StripeEntityOfProduct {
    id?: string | undefined;
    object?: string | undefined;
    active?: boolean | undefined;
    attributes?: string[] | undefined;
    caption?: string | undefined;
    created: string;
    deactivate_on?: string[] | undefined;
    deleted?: boolean | undefined;
    description?: string | undefined;
    images?: string[] | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    name?: string | undefined;
    package_dimensions?: PackageDimensions | undefined;
    shippable?: boolean | undefined;
    statement_descriptor?: string | undefined;
    type?: string | undefined;
    unit_label?: string | undefined;
    updated: string;
    url?: string | undefined;
}

export interface StripeEntityOfPackageDimensions extends StripeEntity {
}

export interface PackageDimensions extends StripeEntityOfPackageDimensions {
    height?: number | undefined;
    length?: number | undefined;
    weight?: number | undefined;
    width?: number | undefined;
}

export interface StripeEntityOfPlanTier extends StripeEntity {
}

export interface PlanTier extends StripeEntityOfPlanTier {
    flat_amount?: number | undefined;
    flat_amount_decimal?: number | undefined;
    unit_amount?: number | undefined;
    unit_amount_decimal?: number | undefined;
    up_to?: number | undefined;
}

export interface StripeEntityOfPlanTransformUsage extends StripeEntity {
}

export interface PlanTransformUsage extends StripeEntityOfPlanTransformUsage {
    divide_by: number;
    round?: string | undefined;
}

export interface ExpandableFieldOfInvoice {
    id?: string | undefined;
    expandedObject?: Invoice | undefined;
}

export interface StripeEntityOfInvoice extends StripeEntity {
}

export interface Invoice extends StripeEntityOfInvoice {
    id?: string | undefined;
    object?: string | undefined;
    account_country?: string | undefined;
    account_name?: string | undefined;
    amount_due: number;
    amount_paid: number;
    amount_remaining: number;
    application_fee_amount?: number | undefined;
    attempt_count: number;
    attempted: boolean;
    auto_advance: boolean;
    billing?: Billing | undefined;
    billing_reason?: string | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    collection_method?: string | undefined;
    created: string;
    currency?: string | undefined;
    custom_fields?: InvoiceCustomField[] | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    customer_address?: Address2 | undefined;
    customer_email?: string | undefined;
    customer_name?: string | undefined;
    customer_phone?: string | undefined;
    customer_shipping?: Shipping | undefined;
    customer_tax_exempt?: string | undefined;
    customer_tax_ids?: InvoiceCustomerTaxId[] | undefined;
    default_payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    default_source?: ExpandableFieldOfIPaymentSource | undefined;
    default_tax_rates?: TaxRate[] | undefined;
    description?: string | undefined;
    discount?: Discount | undefined;
    due_date?: string | undefined;
    ending_balance?: number | undefined;
    footer?: string | undefined;
    hosted_invoice_url?: string | undefined;
    invoice_pdf?: string | undefined;
    lines?: StripeListOfInvoiceLineItem | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    next_payment_attempt?: string | undefined;
    number?: string | undefined;
    paid: boolean;
    payment_intent?: ExpandableFieldOfPaymentIntent | undefined;
    period_end: string;
    period_start: string;
    post_payment_credit_notes_amount?: number | undefined;
    pre_payment_credit_notes_amount?: number | undefined;
    receipt_number?: string | undefined;
    starting_balance: number;
    statement_descriptor?: string | undefined;
    status?: string | undefined;
    status_transitions?: InvoiceStatusTransitions | undefined;
    subscription?: ExpandableFieldOfSubscription | undefined;
    subscription_proration_date: string;
    subtotal: number;
    tax?: number | undefined;
    tax_percent?: number | undefined;
    threshold_reason?: InvoiceThresholdReason | undefined;
    total_tax_amounts?: InvoiceTaxAmount[] | undefined;
    transfer_data?: InvoiceTransferData | undefined;
    total: number;
    webhooks_delivered_at?: string | undefined;
}

export interface ExpandableFieldOfCharge {
    id?: string | undefined;
    expandedObject?: Charge | undefined;
}

export interface StripeEntityOfCharge extends StripeEntity {
}

export interface Charge extends StripeEntityOfCharge {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    amount_refunded: number;
    application?: ExpandableFieldOfApplication | undefined;
    application_fee?: ExpandableFieldOfApplicationFee | undefined;
    application_fee_amount?: number | undefined;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    billing_details?: BillingDetails | undefined;
    captured?: boolean | undefined;
    created: string;
    currency?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    description?: string | undefined;
    destination?: ExpandableFieldOfAccount | undefined;
    dispute?: ExpandableFieldOfDispute | undefined;
    failure_code?: string | undefined;
    failure_message?: string | undefined;
    fraud_details?: { [key: string]: string; } | undefined;
    invoice?: ExpandableFieldOfInvoice | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    on_behalf_of?: ExpandableFieldOfAccount | undefined;
    order?: ExpandableFieldOfOrder | undefined;
    level3?: ChargeLevel3 | undefined;
    outcome?: Outcome | undefined;
    paid: boolean;
    payment_intent?: ExpandableFieldOfPaymentIntent | undefined;
    payment_method?: string | undefined;
    payment_method_details?: ChargePaymentMethodDetails | undefined;
    receipt_email?: string | undefined;
    receipt_number?: string | undefined;
    receipt_url?: string | undefined;
    refunded: boolean;
    refunds?: StripeListOfRefund | undefined;
    review?: ExpandableFieldOfReview | undefined;
    shipping?: Shipping | undefined;
    source?: IPaymentSource | undefined;
    source_transfer?: ExpandableFieldOfTransfer | undefined;
    statement_descriptor?: string | undefined;
    statement_descriptor_suffix?: string | undefined;
    status?: string | undefined;
    transfer?: ExpandableFieldOfTransfer | undefined;
    transfer_data?: ChargeTransferData | undefined;
    transfer_group?: string | undefined;
    authorization_code?: string | undefined;
}

export interface ExpandableFieldOfApplication {
    id?: string | undefined;
    expandedObject?: Application | undefined;
}

export interface StripeEntityOfApplication extends StripeEntity {
}

export interface Application extends StripeEntityOfApplication {
    id?: string | undefined;
    object?: string | undefined;
    name?: string | undefined;
}

export interface ExpandableFieldOfApplicationFee {
    id?: string | undefined;
    expandedObject?: ApplicationFee | undefined;
}

export interface StripeEntityOfApplicationFee extends StripeEntity {
}

export interface ApplicationFee extends StripeEntityOfApplicationFee {
    id?: string | undefined;
    object?: string | undefined;
    account?: ExpandableFieldOfAccount | undefined;
    amount: number;
    amount_refunded: number;
    application?: ExpandableFieldOfApplication | undefined;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    created: string;
    currency?: string | undefined;
    livemode: boolean;
    originating_transaction?: ExpandableFieldOfCharge | undefined;
    refunded: boolean;
    refunds?: StripeListOfApplicationFeeRefund | undefined;
}

export interface ExpandableFieldOfAccount {
    id?: string | undefined;
    expandedObject?: Account | undefined;
}

export interface StripeEntityOfAccount extends StripeEntity {
}

export interface Account extends StripeEntityOfAccount {
    id?: string | undefined;
    object?: string | undefined;
    business_profile?: AccountBusinessProfile | undefined;
    business_type?: string | undefined;
    capabilities?: AccountCapabilities | undefined;
    charges_enabled: boolean;
    company?: AccountCompany | undefined;
    country?: string | undefined;
    created: string;
    default_currency?: string | undefined;
    deleted?: boolean | undefined;
    details_submitted: boolean;
    email?: string | undefined;
    external_accounts?: StripeListOfIExternalAccount | undefined;
    individual?: Person | undefined;
    metadata?: { [key: string]: string; } | undefined;
    payouts_enabled: boolean;
    requirements?: AccountRequirements | undefined;
    settings?: AccountSettings | undefined;
    tos_acceptance?: AccountTosAcceptance | undefined;
    type?: string | undefined;
}

export interface StripeEntityOfAccountBusinessProfile extends StripeEntity {
}

export interface AccountBusinessProfile extends StripeEntityOfAccountBusinessProfile {
    mcc?: string | undefined;
    name?: string | undefined;
    product_description?: string | undefined;
    support_address?: Address2 | undefined;
    support_email?: string | undefined;
    support_phone?: string | undefined;
    support_url?: string | undefined;
    url?: string | undefined;
}

export interface StripeEntityOfAccountCapabilities extends StripeEntity {
}

export interface AccountCapabilities extends StripeEntityOfAccountCapabilities {
    card_payments?: string | undefined;
    legacy_payments?: string | undefined;
    transfers?: string | undefined;
}

export interface StripeEntityOfAccountCompany extends StripeEntity {
}

export interface AccountCompany extends StripeEntityOfAccountCompany {
    address?: Address2 | undefined;
    address_kana?: AddressJapan | undefined;
    address_kanji?: AddressJapan | undefined;
    directors_provided: boolean;
    name?: string | undefined;
    name_kana?: string | undefined;
    name_kanji?: string | undefined;
    owners_provided: boolean;
    phone?: string | undefined;
    tax_id_provided: boolean;
    tax_id_registrar?: string | undefined;
    vat_id_provided: boolean;
    verification?: AccountCompanyVerification | undefined;
}

export interface AddressJapan extends Address2 {
    town?: string | undefined;
}

export interface StripeEntityOfAccountCompanyVerification extends StripeEntity {
}

export interface AccountCompanyVerification extends StripeEntityOfAccountCompanyVerification {
    document?: AccountCompanyVerificationDocument | undefined;
}

export interface StripeEntityOfAccountCompanyVerificationDocument extends StripeEntity {
}

export interface AccountCompanyVerificationDocument extends StripeEntityOfAccountCompanyVerificationDocument {
    back?: ExpandableFieldOfFile | undefined;
    details?: string | undefined;
    details_code?: string | undefined;
    front?: ExpandableFieldOfFile | undefined;
}

export interface ExpandableFieldOfFile {
    id?: string | undefined;
    expandedObject?: File | undefined;
}

export interface StripeEntityOfFile extends StripeEntity {
}

export interface File extends StripeEntityOfFile {
    id?: string | undefined;
    object?: string | undefined;
    created: string;
    filename?: string | undefined;
    links?: StripeListOfFileLink | undefined;
    purpose?: string | undefined;
    size: number;
    title?: string | undefined;
    type?: string | undefined;
    url?: string | undefined;
}

export interface StripeEntityOfStripeListOfFileLink extends StripeEntity {
}

export interface StripeListOfFileLink extends StripeEntityOfStripeListOfFileLink {
    object?: string | undefined;
    data?: FileLink[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface StripeEntityOfFileLink extends StripeEntity {
}

export interface FileLink extends StripeEntityOfFileLink {
    id?: string | undefined;
    object?: string | undefined;
    created: string;
    expired: boolean;
    expires_at?: string | undefined;
    livemode: boolean;
    file?: ExpandableFieldOfFile | undefined;
    metadata?: { [key: string]: string; } | undefined;
    url?: string | undefined;
}

export interface StripeEntityOfStripeListOfIExternalAccount extends StripeEntity {
}

export interface StripeListOfIExternalAccount extends StripeEntityOfStripeListOfIExternalAccount {
    object?: string | undefined;
    data?: IExternalAccount[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface IExternalAccount {
    account?: Account | undefined;
    accountId?: string | undefined;
}

export interface StripeEntityOfPerson extends StripeEntity {
}

export interface Person extends StripeEntityOfPerson {
    id?: string | undefined;
    object?: string | undefined;
    account?: string | undefined;
    address?: Address2 | undefined;
    address_kana?: AddressJapan | undefined;
    address_kanji?: AddressJapan | undefined;
    created: string;
    deleted?: boolean | undefined;
    dob?: Dob | undefined;
    email?: string | undefined;
    first_name?: string | undefined;
    first_name_kana?: string | undefined;
    first_name_kanji?: string | undefined;
    gender?: string | undefined;
    id_number_provided: boolean;
    last_name?: string | undefined;
    last_name_kana?: string | undefined;
    last_name_kanji?: string | undefined;
    maiden_name?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    phone?: string | undefined;
    relationship?: PersonRelationship | undefined;
    requirements?: PersonRequirements | undefined;
    ssn_last_4_provided: boolean;
    verification?: PersonVerification | undefined;
}

export interface StripeEntityOfDob extends StripeEntity {
}

export interface Dob extends StripeEntityOfDob {
    day?: number | undefined;
    month?: number | undefined;
    year?: number | undefined;
}

export interface StripeEntityOfPersonRelationship extends StripeEntity {
}

export interface PersonRelationship extends StripeEntityOfPersonRelationship {
    account_opener: boolean;
    director: boolean;
    executive: boolean;
    owner: boolean;
    percent_ownership?: number | undefined;
    title?: string | undefined;
}

export interface StripeEntityOfPersonRequirements extends StripeEntity {
}

export interface PersonRequirements extends StripeEntityOfPersonRequirements {
    currently_due?: string[] | undefined;
    eventually_due?: string[] | undefined;
    past_due?: string[] | undefined;
    pending_verification?: string[] | undefined;
}

export interface StripeEntityOfPersonVerification extends StripeEntity {
}

export interface PersonVerification extends StripeEntityOfPersonVerification {
    additional_document?: PersonVerificationDocument | undefined;
    details?: string | undefined;
    details_code?: string | undefined;
    document?: PersonVerificationDocument | undefined;
    status?: string | undefined;
}

export interface StripeEntityOfPersonVerificationDocument extends StripeEntity {
}

export interface PersonVerificationDocument extends StripeEntityOfPersonVerificationDocument {
    back?: ExpandableFieldOfFile | undefined;
    details?: string | undefined;
    details_code?: string | undefined;
    front?: ExpandableFieldOfFile | undefined;
}

export interface StripeEntityOfAccountRequirements extends StripeEntity {
}

export interface AccountRequirements extends StripeEntityOfAccountRequirements {
    current_deadline?: string | undefined;
    currently_due?: string[] | undefined;
    disabled_reason?: string | undefined;
    eventually_due?: string[] | undefined;
    past_due?: string[] | undefined;
    pending_verification?: string[] | undefined;
}

export interface StripeEntityOfAccountSettings extends StripeEntity {
}

export interface AccountSettings extends StripeEntityOfAccountSettings {
    branding?: AccountSettingsBranding | undefined;
    card_payments?: AccountSettingsCardPayments | undefined;
    dashboard?: AccountSettingsDashboard | undefined;
    payments?: AccountSettingsPayments | undefined;
    payouts?: AccountSettingsPayouts | undefined;
}

export interface StripeEntityOfAccountSettingsBranding extends StripeEntity {
}

export interface AccountSettingsBranding extends StripeEntityOfAccountSettingsBranding {
    icon?: ExpandableFieldOfFile | undefined;
    logo?: ExpandableFieldOfFile | undefined;
    primary_color?: string | undefined;
}

export interface StripeEntityOfAccountSettingsCardPayments extends StripeEntity {
}

export interface AccountSettingsCardPayments extends StripeEntityOfAccountSettingsCardPayments {
    decline_on?: AccountSettingsDeclineOn | undefined;
    statement_descriptor_prefix?: string | undefined;
}

export interface StripeEntityOfAccountSettingsDeclineOn extends StripeEntity {
}

export interface AccountSettingsDeclineOn extends StripeEntityOfAccountSettingsDeclineOn {
    avs_failure: boolean;
    cvc_failure: boolean;
}

export interface StripeEntityOfAccountSettingsDashboard extends StripeEntity {
}

export interface AccountSettingsDashboard extends StripeEntityOfAccountSettingsDashboard {
    display_name?: string | undefined;
    timezone?: string | undefined;
}

export interface StripeEntityOfAccountSettingsPayments extends StripeEntity {
}

export interface AccountSettingsPayments extends StripeEntityOfAccountSettingsPayments {
    statement_descriptor?: string | undefined;
    statement_descriptor_kana?: string | undefined;
    statement_descriptor_kanji?: string | undefined;
}

export interface StripeEntityOfAccountSettingsPayouts extends StripeEntity {
}

export interface AccountSettingsPayouts extends StripeEntityOfAccountSettingsPayouts {
    debit_negative_balances: boolean;
    schedule?: AccountSettingsPayoutsSchedule | undefined;
    statement_descriptor?: string | undefined;
}

export interface StripeEntityOfAccountSettingsPayoutsSchedule extends StripeEntity {
}

export interface AccountSettingsPayoutsSchedule extends StripeEntityOfAccountSettingsPayoutsSchedule {
    delay_days: number;
    interval?: string | undefined;
    monthly_anchor: number;
    weekly_anchor?: string | undefined;
}

export interface StripeEntityOfAccountTosAcceptance extends StripeEntity {
}

export interface AccountTosAcceptance extends StripeEntityOfAccountTosAcceptance {
    date?: string | undefined;
    ip?: string | undefined;
    user_agent?: string | undefined;
}

export interface ExpandableFieldOfBalanceTransaction {
    id?: string | undefined;
    expandedObject?: BalanceTransaction | undefined;
}

export interface StripeEntityOfBalanceTransaction extends StripeEntity {
}

export interface BalanceTransaction extends StripeEntityOfBalanceTransaction {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    available_on: string;
    created: string;
    currency?: string | undefined;
    description?: string | undefined;
    exchange_rate?: number | undefined;
    fee: number;
    fee_details?: Fee[] | undefined;
    net: number;
    source?: ExpandableFieldOfIBalanceTransactionSource | undefined;
    status?: string | undefined;
    type?: string | undefined;
}

export interface StripeEntityOfFee extends StripeEntity {
}

export interface Fee extends StripeEntityOfFee {
    amount: number;
    application?: string | undefined;
    currency?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
}

export interface ExpandableFieldOfIBalanceTransactionSource {
    id?: string | undefined;
    expandedObject?: IBalanceTransactionSource | undefined;
}

export interface IBalanceTransactionSource {
}

export interface StripeEntityOfStripeListOfApplicationFeeRefund extends StripeEntity {
}

export interface StripeListOfApplicationFeeRefund extends StripeEntityOfStripeListOfApplicationFeeRefund {
    object?: string | undefined;
    data?: ApplicationFeeRefund[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface StripeEntityOfApplicationFeeRefund extends StripeEntity {
}

export interface ApplicationFeeRefund extends StripeEntityOfApplicationFeeRefund {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    created: string;
    currency?: string | undefined;
    fee?: ExpandableFieldOfApplicationFee | undefined;
    metadata?: { [key: string]: string; } | undefined;
}

export interface ExpandableFieldOfDispute {
    id?: string | undefined;
    expandedObject?: Dispute | undefined;
}

export interface StripeEntityOfDispute extends StripeEntity {
}

export interface Dispute extends StripeEntityOfDispute {
    id?: string | undefined;
    object?: string | undefined;
    amount?: number | undefined;
    balance_transactions?: BalanceTransaction[] | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    created?: string | undefined;
    currency?: string | undefined;
    evidence?: Evidence | undefined;
    evidence_details?: EvidenceDetails | undefined;
    is_charge_refundable: boolean;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    reason?: string | undefined;
    status?: string | undefined;
}

export interface StripeEntityOfEvidence extends StripeEntity {
}

export interface Evidence extends StripeEntityOfEvidence {
    access_activity_log?: string | undefined;
    billing_address?: string | undefined;
    cancellation_policy?: ExpandableFieldOfFile | undefined;
    cancellation_policy_disclosure?: string | undefined;
    cancellation_rebuttal?: string | undefined;
    customer_communication?: ExpandableFieldOfFile | undefined;
    customer_email_address?: string | undefined;
    customer_name?: string | undefined;
    customer_purchase_ip?: string | undefined;
    customer_signature?: ExpandableFieldOfFile | undefined;
    duplicate_charge_documentation?: ExpandableFieldOfFile | undefined;
    duplicate_charge_explanation?: string | undefined;
    duplicate_charge_id?: string | undefined;
    product_description?: string | undefined;
    receipt?: ExpandableFieldOfFile | undefined;
    refund_policy?: ExpandableFieldOfFile | undefined;
    refund_policy_disclosure?: string | undefined;
    refund_refusal_explanation?: string | undefined;
    service_date?: string | undefined;
    service_documentation?: ExpandableFieldOfFile | undefined;
    shipping_address?: string | undefined;
    shipping_carrier?: string | undefined;
    shipping_date?: string | undefined;
    shipping_documentation?: ExpandableFieldOfFile | undefined;
    shipping_tracking_number?: string | undefined;
    uncategorized_file?: ExpandableFieldOfFile | undefined;
    uncategorized_text?: string | undefined;
}

export interface StripeEntityOfEvidenceDetails extends StripeEntity {
}

export interface EvidenceDetails extends StripeEntityOfEvidenceDetails {
    due_by?: string | undefined;
    has_evidence: boolean;
    past_due: boolean;
    submission_count: number;
}

export interface ExpandableFieldOfOrder {
    id?: string | undefined;
    expandedObject?: Order | undefined;
}

export interface StripeEntityOfOrder extends StripeEntity {
}

export interface Order extends StripeEntityOfOrder {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    amount_returned?: number | undefined;
    application?: string | undefined;
    application_fee?: number | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    created: string;
    currency?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    email?: string | undefined;
    external_coupon_code?: string | undefined;
    items?: OrderItem[] | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    returns?: StripeListOfOrderReturn | undefined;
    selected_shipping_method?: string | undefined;
    shipping?: Shipping | undefined;
    shipping_methods?: ShippingMethod[] | undefined;
    status?: string | undefined;
    status_transitions?: StatusTransitions | undefined;
    updated: string;
    upstream_id?: string | undefined;
}

export interface StripeEntityOfOrderItem extends StripeEntity {
}

export interface OrderItem extends StripeEntityOfOrderItem {
    object?: string | undefined;
    amount: number;
    currency?: string | undefined;
    description?: string | undefined;
    parent?: ExpandableFieldOfSku | undefined;
    quantity?: number | undefined;
    type?: string | undefined;
}

export interface ExpandableFieldOfSku {
    id?: string | undefined;
    expandedObject?: Sku | undefined;
}

export interface StripeEntityOfSku extends StripeEntity {
}

export interface Sku extends StripeEntityOfSku {
    id?: string | undefined;
    object?: string | undefined;
    active: boolean;
    attributes?: { [key: string]: string; } | undefined;
    created: string;
    currency?: string | undefined;
    deleted?: boolean | undefined;
    image?: string | undefined;
    inventory?: Inventory | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    package_dimensions?: PackageDimensions | undefined;
    price: number;
    product?: ExpandableFieldOfProduct | undefined;
    updated: string;
}

export interface StripeEntityOfInventory extends StripeEntity {
}

export interface Inventory extends StripeEntityOfInventory {
    quantity?: number | undefined;
    type?: string | undefined;
    value?: string | undefined;
}

export interface StripeEntityOfStripeListOfOrderReturn extends StripeEntity {
}

export interface StripeListOfOrderReturn extends StripeEntityOfStripeListOfOrderReturn {
    object?: string | undefined;
    data?: OrderReturn[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface StripeEntityOfOrderReturn extends StripeEntity {
}

export interface OrderReturn extends StripeEntityOfOrderReturn {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    created: string;
    currency?: string | undefined;
    items?: OrderItem[] | undefined;
    livemode: boolean;
    order?: ExpandableFieldOfOrder | undefined;
    refund?: ExpandableFieldOfRefund | undefined;
}

export interface ExpandableFieldOfRefund {
    id?: string | undefined;
    expandedObject?: Refund | undefined;
}

export interface StripeEntityOfRefund extends StripeEntity {
}

export interface Refund extends StripeEntityOfRefund {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    created: string;
    currency?: string | undefined;
    description?: string | undefined;
    failure_balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    failure_reason?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    reason?: string | undefined;
    receipt_number?: string | undefined;
    source_transfer_reversal?: ExpandableFieldOfTransferReversal | undefined;
    status?: string | undefined;
    transfer_reversal?: ExpandableFieldOfTransferReversal | undefined;
}

export interface ExpandableFieldOfTransferReversal {
    id?: string | undefined;
    expandedObject?: TransferReversal | undefined;
}

export interface StripeEntityOfTransferReversal extends StripeEntity {
}

export interface TransferReversal extends StripeEntityOfTransferReversal {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    created: string;
    currency?: string | undefined;
    destination_payment_refund?: ExpandableFieldOfRefund | undefined;
    metadata?: { [key: string]: string; } | undefined;
    source_refund?: ExpandableFieldOfRefund | undefined;
    transfer?: ExpandableFieldOfTransfer | undefined;
}

export interface ExpandableFieldOfTransfer {
    id?: string | undefined;
    expandedObject?: Transfer | undefined;
}

export interface StripeEntityOfTransfer extends StripeEntity {
}

export interface Transfer extends StripeEntityOfTransfer {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    amount_reversed: number;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    created: string;
    currency?: string | undefined;
    description?: string | undefined;
    destination?: ExpandableFieldOfAccount | undefined;
    destination_payment?: ExpandableFieldOfCharge | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    reversals?: StripeListOfTransferReversal | undefined;
    reversed: boolean;
    source_transaction?: ExpandableFieldOfCharge | undefined;
    source_type?: string | undefined;
    transfer_group?: string | undefined;
}

export interface StripeEntityOfStripeListOfTransferReversal extends StripeEntity {
}

export interface StripeListOfTransferReversal extends StripeEntityOfStripeListOfTransferReversal {
    object?: string | undefined;
    data?: TransferReversal[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface StripeEntityOfShipping extends StripeEntity {
}

export interface Shipping extends StripeEntityOfShipping {
    address?: Address2 | undefined;
    carrier?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    tracking_number?: string | undefined;
}

export interface StripeEntityOfShippingMethod extends StripeEntity {
}

export interface ShippingMethod extends StripeEntityOfShippingMethod {
    id?: string | undefined;
    amount: number;
    currency?: string | undefined;
    delivery_estimate?: DeliveryEstimate | undefined;
    description?: string | undefined;
}

export interface StripeEntityOfDeliveryEstimate extends StripeEntity {
}

export interface DeliveryEstimate extends StripeEntityOfDeliveryEstimate {
    date?: string | undefined;
    earliest?: string | undefined;
    latest?: string | undefined;
    type?: string | undefined;
}

export interface StripeEntityOfStatusTransitions extends StripeEntity {
}

export interface StatusTransitions extends StripeEntityOfStatusTransitions {
    canceled?: string | undefined;
    fulfiled?: string | undefined;
    paid?: string | undefined;
    returned?: string | undefined;
}

export interface StripeEntityOfChargeLevel3 extends StripeEntity {
}

export interface ChargeLevel3 extends StripeEntityOfChargeLevel3 {
    customer_reference?: string | undefined;
    line_items?: ChargeLevel3LineItem[] | undefined;
    merchant_reference?: string | undefined;
    shipping_address_zip?: string | undefined;
    shipping_from_zip?: string | undefined;
    shipping_amount: number;
}

export interface StripeEntityOfChargeLevel3LineItem extends StripeEntity {
}

export interface ChargeLevel3LineItem extends StripeEntityOfChargeLevel3LineItem {
    discount_amount?: number | undefined;
    product_code?: string | undefined;
    product_description?: string | undefined;
    quantity?: number | undefined;
    tax_amount?: number | undefined;
    unit_cost?: number | undefined;
}

export interface StripeEntityOfOutcome extends StripeEntity {
}

export interface Outcome extends StripeEntityOfOutcome {
    network_status?: string | undefined;
    reason?: string | undefined;
    risk_level?: string | undefined;
    risk_score: number;
    rule?: ExpandableFieldOfOutcomeRule | undefined;
    seller_message?: string | undefined;
    type?: string | undefined;
}

export interface ExpandableFieldOfOutcomeRule {
    id?: string | undefined;
    expandedObject?: OutcomeRule | undefined;
}

export interface StripeEntityOfOutcomeRule extends StripeEntity {
}

export interface OutcomeRule extends StripeEntityOfOutcomeRule {
    id?: string | undefined;
    action?: string | undefined;
    predicate?: string | undefined;
}

export interface ExpandableFieldOfPaymentIntent {
    id?: string | undefined;
    expandedObject?: PaymentIntent | undefined;
}

export interface StripeEntityOfPaymentIntent extends StripeEntity {
}

export interface PaymentIntent extends StripeEntityOfPaymentIntent {
    id?: string | undefined;
    object?: string | undefined;
    amount?: number | undefined;
    amount_capturable?: number | undefined;
    amount_received?: number | undefined;
    application?: ExpandableFieldOfApplication | undefined;
    application_fee_amount?: number | undefined;
    canceled_at?: string | undefined;
    cancellation_reason?: string | undefined;
    capture_method?: string | undefined;
    charges?: StripeListOfCharge | undefined;
    client_secret?: string | undefined;
    confirmation_method?: string | undefined;
    created?: string | undefined;
    currency?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    description?: string | undefined;
    invoice?: ExpandableFieldOfInvoice | undefined;
    last_payment_error?: StripeError | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    next_action?: PaymentIntentNextAction | undefined;
    on_behalf_of?: ExpandableFieldOfAccount | undefined;
    payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    payment_method_options?: PaymentIntentPaymentMethodOptions | undefined;
    payment_method_types?: string[] | undefined;
    receipt_email?: string | undefined;
    review?: ExpandableFieldOfReview | undefined;
    setup_future_usage?: string | undefined;
    shipping?: Shipping | undefined;
    source?: ExpandableFieldOfIPaymentSource | undefined;
    statement_descriptor?: string | undefined;
    statement_descriptor_suffix?: string | undefined;
    status?: string | undefined;
    transfer_data?: PaymentIntentTransferData | undefined;
    transfer_group?: string | undefined;
    allowed_source_types?: string[] | undefined;
}

export interface StripeEntityOfStripeListOfCharge extends StripeEntity {
}

export interface StripeListOfCharge extends StripeEntityOfStripeListOfCharge {
    object?: string | undefined;
    data?: Charge[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface StripeEntityOfStripeError extends StripeEntity {
}

export interface StripeError extends StripeEntityOfStripeError {
    charge?: string | undefined;
    code?: string | undefined;
    decline_code?: string | undefined;
    doc_url?: string | undefined;
    message?: string | undefined;
    param?: string | undefined;
    payment_intent?: PaymentIntent | undefined;
    payment_method?: PaymentMethod | undefined;
    setup_intent?: SetupIntent | undefined;
    source?: IPaymentSource | undefined;
    type?: string | undefined;
    error?: string | undefined;
    error_description?: string | undefined;
}

export interface StripeEntityOfSetupIntent extends StripeEntity {
}

export interface SetupIntent extends StripeEntityOfSetupIntent {
    id?: string | undefined;
    object?: string | undefined;
    application?: ExpandableFieldOfApplication | undefined;
    cancellation_reason?: string | undefined;
    client_secret?: string | undefined;
    created?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    description?: string | undefined;
    last_setup_error?: StripeError | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    next_action?: SetupIntentNextAction | undefined;
    on_behalf_of?: ExpandableFieldOfAccount | undefined;
    payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    payment_method_options?: SetupIntentPaymentMethodOptions | undefined;
    payment_method_types?: string[] | undefined;
    status?: string | undefined;
    usage?: string | undefined;
}

export interface StripeEntityOfSetupIntentNextAction extends StripeEntity {
}

export interface SetupIntentNextAction extends StripeEntityOfSetupIntentNextAction {
    redirect_to_url?: SetupIntentNextActionRedirectToUrl | undefined;
    type?: string | undefined;
}

export interface StripeEntityOfSetupIntentNextActionRedirectToUrl extends StripeEntity {
}

export interface SetupIntentNextActionRedirectToUrl extends StripeEntityOfSetupIntentNextActionRedirectToUrl {
    return_url?: string | undefined;
    url?: string | undefined;
}

export interface StripeEntityOfSetupIntentPaymentMethodOptions extends StripeEntity {
}

export interface SetupIntentPaymentMethodOptions extends StripeEntityOfSetupIntentPaymentMethodOptions {
    card?: SetupIntentPaymentMethodOptionsCard | undefined;
}

export interface StripeEntityOfSetupIntentPaymentMethodOptionsCard extends StripeEntity {
}

export interface SetupIntentPaymentMethodOptionsCard extends StripeEntityOfSetupIntentPaymentMethodOptionsCard {
    request_three_d_secure?: string | undefined;
}

export interface StripeEntityOfPaymentIntentNextAction extends StripeEntity {
}

export interface PaymentIntentNextAction extends StripeEntityOfPaymentIntentNextAction {
    redirect_to_url?: PaymentIntentNextActionRedirectToUrl | undefined;
    type?: string | undefined;
}

export interface StripeEntityOfPaymentIntentNextActionRedirectToUrl extends StripeEntity {
}

export interface PaymentIntentNextActionRedirectToUrl extends StripeEntityOfPaymentIntentNextActionRedirectToUrl {
    return_url?: string | undefined;
    url?: string | undefined;
}

export interface StripeEntityOfPaymentIntentPaymentMethodOptions extends StripeEntity {
}

export interface PaymentIntentPaymentMethodOptions extends StripeEntityOfPaymentIntentPaymentMethodOptions {
    card?: PaymentIntentPaymentMethodOptionsCard | undefined;
}

export interface StripeEntityOfPaymentIntentPaymentMethodOptionsCard extends StripeEntity {
}

export interface PaymentIntentPaymentMethodOptionsCard extends StripeEntityOfPaymentIntentPaymentMethodOptionsCard {
    request_three_d_secure?: string | undefined;
}

export interface ExpandableFieldOfReview {
    id?: string | undefined;
    expandedObject?: Review | undefined;
}

export interface StripeEntityOfReview extends StripeEntity {
}

export interface Review extends StripeEntityOfReview {
    id?: string | undefined;
    object?: string | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    created: string;
    livemode: boolean;
    open: boolean;
    payment_intent?: ExpandableFieldOfPaymentIntent | undefined;
    reason?: string | undefined;
}

export interface StripeEntityOfPaymentIntentTransferData extends StripeEntity {
}

export interface PaymentIntentTransferData extends StripeEntityOfPaymentIntentTransferData {
    amount?: number | undefined;
    destination?: ExpandableFieldOfAccount | undefined;
}

export interface ChargePaymentMethodDetails extends StripeEntity {
    ach_credit_transfer?: ChargePaymentMethodDetailsAchCreditTransfer | undefined;
    ach_debit?: ChargePaymentMethodDetailsAchDebit | undefined;
    acss_debit?: ChargePaymentMethodDetailsAchDebit | undefined;
    alipay?: ChargePaymentMethodDetailsAlipay | undefined;
    bancontact?: ChargePaymentMethodDetailsBancontact | undefined;
    bitcoin?: ChargePaymentMethodDetailsBitcoin | undefined;
    card?: ChargePaymentMethodDetailsCard | undefined;
    card_present?: ChargePaymentMethodDetailsCardPresent | undefined;
    eps?: ChargePaymentMethodDetailsEps | undefined;
    giropay?: ChargePaymentMethodDetailsGiropay | undefined;
    ideal?: ChargePaymentMethodDetailsIdeal | undefined;
    klarna?: ChargePaymentMethodDetailsKlarna | undefined;
    multibanco?: ChargePaymentMethodDetailsMultibanco | undefined;
    p24?: ChargePaymentMethodDetailsP24 | undefined;
    sepa_debit?: ChargePaymentMethodDetailsSepaDebit | undefined;
    stripe_account?: ChargePaymentMethodDetailsStripeAccount | undefined;
    type?: string | undefined;
    wechat?: ChargePaymentMethodDetailsWechat | undefined;
}

export interface ChargePaymentMethodDetailsAchCreditTransfer extends StripeEntity {
    account_number?: string | undefined;
    bank_name?: string | undefined;
    routing_number?: string | undefined;
    swift_code?: string | undefined;
}

export interface ChargePaymentMethodDetailsAchDebit extends StripeEntity {
    account_holder_type?: string | undefined;
    bank_name?: string | undefined;
    country?: string | undefined;
    fingerprint?: string | undefined;
    last4?: string | undefined;
    routing_number?: string | undefined;
}

export interface ChargePaymentMethodDetailsAlipay extends StripeEntity {
}

export interface ChargePaymentMethodDetailsBancontact extends StripeEntity {
    bank_code?: string | undefined;
    bank_name?: string | undefined;
    bic?: string | undefined;
    iban_last4?: string | undefined;
    preferred_language?: string | undefined;
    verified_name?: string | undefined;
}

export interface ChargePaymentMethodDetailsBitcoin extends StripeEntity {
    address?: string | undefined;
    amount: number;
    amount_charged: number;
    amount_received: number;
    amount_returned: number;
    refund_address?: string | undefined;
}

export interface ChargePaymentMethodDetailsCard extends StripeEntity {
    brand?: string | undefined;
    checks?: ChargePaymentMethodDetailsCardChecks | undefined;
    country?: string | undefined;
    exp_month: number;
    exp_year: number;
    fingerprint?: string | undefined;
    funding?: string | undefined;
    last4?: string | undefined;
    moto?: boolean | undefined;
    three_d_secure?: ChargePaymentMethodDetailsCardThreeDSecure | undefined;
    wallet?: ChargePaymentMethodDetailsCardWallet | undefined;
}

export interface ChargePaymentMethodDetailsCardChecks extends StripeEntity {
    address_line1_check?: string | undefined;
    address_postal_code_check?: string | undefined;
    cvc_check?: string | undefined;
}

export interface ChargePaymentMethodDetailsCardThreeDSecure extends StripeEntity {
    authenticated: boolean;
    succeeded: boolean;
    version?: string | undefined;
}

export interface ChargePaymentMethodDetailsCardWallet extends StripeEntity {
    amex_express_checkout?: ChargePaymentMethodDetailsCardWalletAmexExpressCheckout | undefined;
    apple_pay?: ChargePaymentMethodDetailsCardWalletApplePay | undefined;
    dynamic_last4?: string | undefined;
    google_pay?: ChargePaymentMethodDetailsCardWalletGooglePay | undefined;
    masterpass?: ChargePaymentMethodDetailsCardWalletMasterpass | undefined;
    samsung_pay?: ChargePaymentMethodDetailsCardWalletSamsungPay | undefined;
    type?: string | undefined;
    visa_checkout?: ChargePaymentMethodDetailsCardWalletVisaCheckout | undefined;
}

export interface ChargePaymentMethodDetailsCardWalletAmexExpressCheckout extends StripeEntity {
}

export interface ChargePaymentMethodDetailsCardWalletApplePay extends StripeEntity {
}

export interface ChargePaymentMethodDetailsCardWalletGooglePay extends StripeEntity {
}

export interface ChargePaymentMethodDetailsCardWalletMasterpass extends StripeEntity {
    billing_address?: Address2 | undefined;
    email?: string | undefined;
    name?: string | undefined;
    shipping_address?: Address2 | undefined;
}

export interface ChargePaymentMethodDetailsCardWalletSamsungPay extends StripeEntity {
}

export interface ChargePaymentMethodDetailsCardWalletVisaCheckout extends StripeEntity {
    billing_address?: Address2 | undefined;
    email?: string | undefined;
    name?: string | undefined;
    shipping_address?: Address2 | undefined;
}

export interface ChargePaymentMethodDetailsCardPresent extends StripeEntity {
    brand?: string | undefined;
    country?: string | undefined;
    emv_auth_data?: string | undefined;
    exp_month: number;
    exp_year: number;
    fingerprint?: string | undefined;
    funding?: string | undefined;
    generated_card?: string | undefined;
    last4?: string | undefined;
    read_method?: string | undefined;
    receipt?: ChargePaymentMethodDetailsCardPresentReceipt | undefined;
}

export interface ChargePaymentMethodDetailsCardPresentReceipt extends StripeEntity {
    application_cryptogram?: string | undefined;
    application_preferred_name?: string | undefined;
    authorization_code?: string | undefined;
    authorization_response_code?: string | undefined;
    cardholder_verification_method?: string | undefined;
    dedicated_file_name?: string | undefined;
    terminal_verification_results?: string | undefined;
    transaction_status_information?: string | undefined;
}

export interface ChargePaymentMethodDetailsEps extends StripeEntity {
    verified_name?: string | undefined;
}

export interface ChargePaymentMethodDetailsGiropay extends StripeEntity {
    bank_code?: string | undefined;
    bank_name?: string | undefined;
    bic?: string | undefined;
    verified_name?: string | undefined;
}

export interface ChargePaymentMethodDetailsIdeal extends StripeEntity {
    bank?: string | undefined;
    bic?: string | undefined;
    iban_last4?: string | undefined;
    verified_name?: string | undefined;
}

export interface ChargePaymentMethodDetailsKlarna extends StripeEntity {
}

export interface ChargePaymentMethodDetailsMultibanco extends StripeEntity {
    entity?: string | undefined;
    reference?: string | undefined;
}

export interface ChargePaymentMethodDetailsP24 extends StripeEntity {
    reference?: string | undefined;
    verified_name?: string | undefined;
}

export interface ChargePaymentMethodDetailsSepaDebit extends StripeEntity {
    bank_code?: string | undefined;
    branch_code?: string | undefined;
    country?: string | undefined;
    fingerprint?: string | undefined;
    last4?: string | undefined;
}

export interface ChargePaymentMethodDetailsStripeAccount extends StripeEntity {
}

export interface ChargePaymentMethodDetailsWechat extends StripeEntity {
}

export interface StripeEntityOfStripeListOfRefund extends StripeEntity {
}

export interface StripeListOfRefund extends StripeEntityOfStripeListOfRefund {
    object?: string | undefined;
    data?: Refund[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface StripeEntityOfChargeTransferData extends StripeEntity {
}

export interface ChargeTransferData extends StripeEntityOfChargeTransferData {
    amount?: number | undefined;
    destination?: ExpandableFieldOfAccount | undefined;
}

export interface StripeEntityOfInvoiceCustomField extends StripeEntity {
}

export interface InvoiceCustomField extends StripeEntityOfInvoiceCustomField {
    name?: string | undefined;
    value?: string | undefined;
}

export interface InvoiceCustomerTaxId extends StripeEntity {
    type?: string | undefined;
    value?: string | undefined;
}

export interface StripeEntityOfStripeListOfInvoiceLineItem extends StripeEntity {
}

export interface StripeListOfInvoiceLineItem extends StripeEntityOfStripeListOfInvoiceLineItem {
    object?: string | undefined;
    data?: InvoiceLineItem[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface StripeEntityOfInvoiceLineItem extends StripeEntity {
}

export interface InvoiceLineItem extends StripeEntityOfInvoiceLineItem {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    currency?: string | undefined;
    date: string;
    description?: string | undefined;
    discountable: boolean;
    invoice_item?: string | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    period?: Period | undefined;
    plan?: Plan | undefined;
    proration: boolean;
    quantity?: number | undefined;
    subscription?: string | undefined;
    subscription_item?: string | undefined;
    tax_amounts?: InvoiceTaxAmount[] | undefined;
    tax_rates?: TaxRate[] | undefined;
    type?: string | undefined;
    unified_proration: boolean;
}

export interface StripeEntityOfPeriod extends StripeEntity {
}

export interface Period extends StripeEntityOfPeriod {
    start?: string | undefined;
    end?: string | undefined;
}

export interface InvoiceTaxAmount extends StripeEntity {
    amount: number;
    inclusive: boolean;
    tax_rate?: ExpandableFieldOfTaxRate | undefined;
}

export interface ExpandableFieldOfTaxRate {
    id?: string | undefined;
    expandedObject?: TaxRate | undefined;
}

export interface InvoiceStatusTransitions extends StripeEntity {
    finalized_at?: string | undefined;
    marked_uncollectible_at?: string | undefined;
    paid_at?: string | undefined;
    voided_at?: string | undefined;
}

export interface StripeEntityOfInvoiceThresholdReason extends StripeEntity {
}

export interface InvoiceThresholdReason extends StripeEntityOfInvoiceThresholdReason {
    amount_gte?: number | undefined;
    item_reasons?: InvoiceThresholdReasonItemReason[] | undefined;
}

export interface StripeEntityOfInvoiceThresholdReasonItemReason extends StripeEntity {
}

export interface InvoiceThresholdReasonItemReason extends StripeEntityOfInvoiceThresholdReasonItemReason {
    line_item_ids?: string[] | undefined;
    usage_gte?: number | undefined;
}

export interface StripeEntityOfInvoiceTransferData extends StripeEntity {
}

export interface InvoiceTransferData extends StripeEntityOfInvoiceTransferData {
    destination?: ExpandableFieldOfAccount | undefined;
}

export interface ExpandableFieldOfSetupIntent {
    id?: string | undefined;
    expandedObject?: SetupIntent | undefined;
}

export interface ExpandableFieldOfSubscriptionSchedule {
    id?: string | undefined;
    expandedObject?: SubscriptionSchedule | undefined;
}

export interface StripeEntityOfSubscriptionSchedule extends StripeEntity {
}

export interface SubscriptionSchedule extends StripeEntityOfSubscriptionSchedule {
    id?: string | undefined;
    object?: string | undefined;
    billing?: Billing | undefined;
    billing_thresholds?: SubscriptionBillingThresholds | undefined;
    canceled_at?: string | undefined;
    collection_method?: string | undefined;
    completed_at?: string | undefined;
    created?: string | undefined;
    current_phase?: SubscriptionScheduleCurrentPhase | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    default_payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    default_source?: ExpandableFieldOfIPaymentSource | undefined;
    end_behavior?: string | undefined;
    invoice_settings?: SubscriptionScheduleInvoiceSettings | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    phases?: SubscriptionSchedulePhase[] | undefined;
    released_at?: string | undefined;
    released_subscription?: string | undefined;
    renewal_behavior?: string | undefined;
    renewal_interval?: SubscriptionScheduleRenewalInterval | undefined;
    status?: string | undefined;
    subscription?: ExpandableFieldOfSubscription | undefined;
}

export interface StripeEntityOfSubscriptionScheduleCurrentPhase extends StripeEntity {
}

export interface SubscriptionScheduleCurrentPhase extends StripeEntityOfSubscriptionScheduleCurrentPhase {
    end_date?: string | undefined;
    start_date?: string | undefined;
}

export interface StripeEntityOfSubscriptionScheduleInvoiceSettings extends StripeEntity {
}

export interface SubscriptionScheduleInvoiceSettings extends StripeEntityOfSubscriptionScheduleInvoiceSettings {
    days_until_due?: number | undefined;
}

export interface StripeEntityOfSubscriptionSchedulePhase extends StripeEntity {
}

export interface SubscriptionSchedulePhase extends StripeEntityOfSubscriptionSchedulePhase {
    application_fee_percent?: number | undefined;
    billing_thresholds?: SubscriptionBillingThresholds | undefined;
    collection_method?: string | undefined;
    coupon?: ExpandableFieldOfCoupon | undefined;
    default_payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    default_tax_rates?: TaxRate[] | undefined;
    end_date?: string | undefined;
    invoice_settings?: SubscriptionScheduleInvoiceSettings | undefined;
    plans?: SubscriptionSchedulePhaseItem[] | undefined;
    start_date?: string | undefined;
    tax_percent?: number | undefined;
    trial_end?: string | undefined;
}

export interface ExpandableFieldOfCoupon {
    id?: string | undefined;
    expandedObject?: Coupon | undefined;
}

export interface StripeEntityOfSubscriptionSchedulePhaseItem extends StripeEntity {
}

export interface SubscriptionSchedulePhaseItem extends StripeEntityOfSubscriptionSchedulePhaseItem {
    billing_thresholds?: SubscriptionItemBillingThresholds | undefined;
    plan?: ExpandableFieldOfPlan | undefined;
    quantity: number;
    tax_rates?: TaxRate[] | undefined;
}

export interface StripeEntityOfSubscriptionItemBillingThresholds extends StripeEntity {
}

export interface SubscriptionItemBillingThresholds extends StripeEntityOfSubscriptionItemBillingThresholds {
    usage_gte?: number | undefined;
}

export interface ExpandableFieldOfPlan {
    id?: string | undefined;
    expandedObject?: Plan | undefined;
}

export interface StripeEntityOfSubscriptionScheduleRenewalInterval extends StripeEntity {
}

export interface SubscriptionScheduleRenewalInterval extends StripeEntityOfSubscriptionScheduleRenewalInterval {
    interval?: string | undefined;
    length: number;
}

export interface StripeEntityOfSubscriptionTransferData extends StripeEntity {
}

export interface SubscriptionTransferData extends StripeEntityOfSubscriptionTransferData {
    destination?: ExpandableFieldOfAccount | undefined;
}

export interface StripeEntityOfCustomerInvoiceSettings extends StripeEntity {
}

export interface CustomerInvoiceSettings extends StripeEntityOfCustomerInvoiceSettings {
    custom_fields?: InvoiceCustomField[] | undefined;
    default_payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    footer?: string | undefined;
}

export interface StripeEntityOfStripeListOfIPaymentSource extends StripeEntity {
}

export interface StripeListOfIPaymentSource extends StripeEntityOfStripeListOfIPaymentSource {
    object?: string | undefined;
    data?: IPaymentSource[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface StripeEntityOfStripeListOfSubscription extends StripeEntity {
}

export interface StripeListOfSubscription extends StripeEntityOfStripeListOfSubscription {
    object?: string | undefined;
    data?: Subscription[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface StripeEntityOfStripeListOfTaxId extends StripeEntity {
}

export interface StripeListOfTaxId extends StripeEntityOfStripeListOfTaxId {
    object?: string | undefined;
    data?: TaxId[] | undefined;
    has_more: boolean;
    url?: string | undefined;
}

export interface TaxId extends StripeEntity {
    id?: string | undefined;
    object?: string | undefined;
    country?: string | undefined;
    created: string;
    customer?: ExpandableFieldOfCustomer | undefined;
    deleted?: boolean | undefined;
    livemode: boolean;
    type?: string | undefined;
    value?: string | undefined;
    verification?: TaxIdVerification | undefined;
}

export interface TaxIdVerification extends StripeEntity {
    status?: string | undefined;
    verified_address?: string | undefined;
    verified_name?: string | undefined;
}

export interface StripeEntityOfCustomerTaxInfo extends StripeEntity {
}

export interface CustomerTaxInfo extends StripeEntityOfCustomerTaxInfo {
    tax_id?: string | undefined;
    type?: string | undefined;
}

export interface StripeEntityOfCustomerTaxInfoVerification extends StripeEntity {
}

export interface CustomerTaxInfoVerification extends StripeEntityOfCustomerTaxInfoVerification {
    status?: string | undefined;
    verified_name?: string | undefined;
}

export interface SessionDisplayItem extends StripeEntity {
    amount?: number | undefined;
    currency?: string | undefined;
    custom?: SessionDisplayItemCustom | undefined;
    plan?: Plan | undefined;
    quantity?: number | undefined;
    sku?: Sku | undefined;
    type?: string | undefined;
}

export interface SessionDisplayItemCustom extends StripeEntity {
    description?: string | undefined;
    images?: string[] | undefined;
    name?: string | undefined;
}

export interface RewardBoxViewModel {
    customerId: string;
    boxId: string;
    orderHeaderId?: string | undefined;
    proceedToStripe: boolean;
}

export interface SubscriptionSignupViewModel {
    customerId: string;
    packId: string;
    successUrl?: string | undefined;
    cancelUrl?: string | undefined;
}

export interface ExternalAppConfig {
    id: string;
    headerText?: string | undefined;
    headerTextEnabled: boolean;
    specialsText?: string | undefined;
    specialsTextEnabled: boolean;
    footerText?: string | undefined;
    footerTextEnabled: boolean;
    tandCsText?: string | undefined;
    tandCsTextEnabled: boolean;
}

export interface OrderHistoryDTO {
    orderId: string;
    orderDate?: string | undefined;
    total: number;
    shipped: boolean;
    invoiced: boolean;
    invoiceId?: string | undefined;
    orderLines?: OrderHistoryLine[] | undefined;
}

export interface OrderHistoryLine {
    orderLineId: string;
    product?: Product | undefined;
    quantity: number;
}

export interface ProductDTO {
    productID: string;
    name?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    sellPrice: number;
    imageId?: string | undefined;
    active: boolean;
    showRemainingUnits: boolean;
    remainingUnits: number;
    applyMaxPurchaseUnits: boolean;
    maxPurchaseUnits: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}